var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "auto",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4847 9.06264C10.2376 8.91777 9.93384 8.92081 9.68793 9.0669L8.44254 9.80889C8.16376 9.97507 7.81559 9.95559 7.55994 9.75594C7.11803 9.41081 6.40647 8.83012 5.78744 8.21108C5.1684 7.59204 4.58771 6.88048 4.24258 6.43857C4.04293 6.18292 4.02345 5.83475 4.18962 5.55597L4.93162 4.31059C5.07831 4.06468 5.07953 3.75851 4.93466 3.51138L3.10737 0.390008C2.93024 0.0880977 2.57842 -0.0604229 2.23816 0.0229678C1.90764 0.103315 1.47851 0.299313 1.02869 0.749745C-0.379818 2.15826 -1.1279 4.53398 4.16893 9.83081C9.46575 15.1276 11.8409 14.3802 13.25 12.971C13.701 12.52 13.8964 12.0903 13.9774 11.7591C14.0595 11.4195 13.9135 11.0701 13.6122 10.8936C12.8598 10.4535 11.237 9.50333 10.4847 9.06264Z",
    fill: "auto"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.c872bac3b642a2cb9f459969f68629f8.svg";
export { ForwardRef as ReactComponent };